import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { withFormik } from 'formik';
import Button from './Button';
import TextInput from './TextInput';

import { isEmptyObject } from '../../validators/formValidators';
import { validateResetPasswordForm } from '../../validators/logInFormValidator';
import { caseSetServerError } from '../../actions/caseActions';
import { userLogOutAction, resetPasswordUserFormAction } from '../../actions/userActions';
import { getObjectValue } from '../../helpers/utils';


class ResetPasswordForm extends PureComponent {
    constructor(props) {
        super(props);
        this.resetPassword = this.resetPassword.bind(this);
        this.state = { loading: false };
    }

    resetPassword(data) {
        if (!isEmptyObject(validateResetPasswordForm(data))) {
            return undefined;
        }

        data['$ResetPasswordToken$'] = this.props.resetToken;
        if (this.props.resetToken) {
            this.props.dispatch(userLogOutAction())
        }

        this.setState({ loading: true });
        return new Promise((resolve, reject) => {
            this.props.dispatch(resetPasswordUserFormAction(data))
                .then((result) => {
                    if (result) {
                        const token = result.data.token;
                        if (this.props.redirectOnSuccess) {
                            browserHistory.push(this.props.redirectOnSuccess);
                        }

                        resolve(result);
                    }

                    this.setState({ loading: false });
                })
                .catch((error) => {
                    console.error(new Error().stack, error);
                    this.setState({ loading: false });
                    this.props.dispatch(caseSetServerError(error));
                    reject(error);
                });
        });
    }

    render() {
        const {
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            isSubmitting,
            centerButton=true,
        } = this.props;

        let loading = this.state.loading;
        return (
            <form ref="resetPasswordForm" onSubmit={handleSubmit}>
                {!this.props.hideEmail && (
                <Row>
                    <Col xs={12}>
                        <TextInput field={{
                                       name: 'Email',
                                       onChange: handleChange,
                                       onBlur: handleBlur,
                                       error: errors['Email'],
                                       touched: touched['Email'],
                                       value: values['Email'],
                                   }}
                                   placeholder="Enter your email"
                                   label="Email"
                                   disabled={loading || isSubmitting}
                        />
                    </Col>
                </Row>)}
                <Row>
                    <Col xs={12}>
                        <TextInput field={{
                                       name: 'Password',
                                       onChange: handleChange,
                                       onBlur: handleBlur,
                                       error: errors['Password'],
                                       touched: touched['Password'],
                                       value: values['Password'],
                                   }}
                                   placeholder="Change your password"
                                   label="Password"
                                   disabled={loading || isSubmitting}
                                   type="password"
                        />
                    </Col>
                </Row>
                <Row>
                    {centerButton && <Col md={4} xs={2} />}
                    <Col xs={6} sm={6} md={5} lg={3}>
                        <Button block
                                style={{ width: 160, marginLeft: centerButton ? 0 : 15 }}
                                label="Change Password"
                                loading={loading}
                                disabled={loading}
                                loadingLabel="Processing ..."
                                onClick={() => { this.resetPassword(values); }}
                        />
                    </Col>
                </Row>
            </form>
        );
    }
}

ResetPasswordForm.propTypes = {
    serverError: PropTypes.string,
    hideEmail: PropTypes.bool,
    redirectOnSuccess: PropTypes.string
};

const mapStateToProps = (state) => {
    let Email;
    let user = getObjectValue(state, 'user.loggedIn');
    if (user) {
        Email = user['Email'];
    }

    const queryEmail = getObjectValue(state, 'routing.locationBeforeTransitions.query.email');
    if (queryEmail) {
        Email = queryEmail;
    }

    const resetToken = getObjectValue(state, 'routing.locationBeforeTransitions.query.token');
    return {
        user,
        resetToken,
        initialValues: { Email }
    };
};


const formikWrapper = { 
    mapPropsToValues: props => props.initialValues,
    validate: validateResetPasswordForm,
};

export default connect(mapStateToProps)(withFormik(formikWrapper)(ResetPasswordForm));

